import React from 'react';
import {
  HomefieldIconMoneyDollarsignFilled,
  HomefieldIconBuildingStoreDsgAlt,
  HomefieldIconVehicleShipping,
  HomefieldIconSportsMatterRibbonAlt,
  HomefieldIconOrderReturns,
} from '@dsg-tech/homefield-react-icons';
import useLogger from 'hooks/useLogger';
import './TopMessageCard.scss';
import { TextLink } from '@dsg-tech/homefield-react';

const icons = {
  dollar_sign_icon: <HomefieldIconMoneyDollarsignFilled width="32px" height="32px" />,
  storefront_icon: <HomefieldIconBuildingStoreDsgAlt width="32px" height="32px" />,
  box_truck_icon: <HomefieldIconVehicleShipping width="32px" height="32px" />,
  ribbon_icon: <HomefieldIconSportsMatterRibbonAlt width="32px" height="32px" />,
  returns_icon: <HomefieldIconOrderReturns width="32px" height="32px" />,
};

interface TopMessageCardProps {
  topText: string;
  bottomText: string;
  link: string;
  ctaText: string;
  icon: keyof typeof icons;
}

const TopMessageCard = ({ topText, bottomText, link, ctaText, icon }: TopMessageCardProps) => {
  const { error } = useLogger();
  try {
    const emdata = `Footer_${topText.replace(/[^A-Z0-9]+/gi, '')}`;

    return (
      <div className="top-section-card hmf-display-flex">
        <div className="hmf-display-flex hmf-mr-s" aria-hidden="true">
          {icons[icon]}
        </div>

        <div className="hmf-display-flex hmf-flex-column">
          <div className="hmf-body-bold-l" data-testid="top-message-card-top-text">
            {topText}
          </div>
          <div className="hmf-body-s hmf-pb-xxxs" data-testid="top-message-card-bottom-text">
            {bottomText}
          </div>
          <div>
            <TextLink
              variant="secondary"
              size="small"
              href={link}
              data-em={emdata}
              data-testid="top-message-card-link">
              {ctaText}
            </TextLink>
          </div>
        </div>
      </div>
    );
  } catch (e) {
    error('Could not load TopMessageCard - ', e);
    return null;
  }
};

export default TopMessageCard;
